import React from 'react';

/**
 * ConversionUrgencyBanner
 *
 * Props:
 * - showUrgency: boolean flag to control visibility of the urgency banner
 */
const ConversionUrgencyBanner = ({ showUrgency }) => {
  if (!showUrgency) return null;

  return (
    <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6 animate-pulse">
      <div className="flex items-center">
        <svg
          className="w-5 h-5 text-red-600 mt-0.5 mr-3 flex-shrink-0"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <div>
          <p className="text-red-800 font-bold">
            ⚡ Limited Time: Join facilities achieving $500K+ annual value from $990 investment
          </p>
          <p className="text-red-700 text-sm">
            Typical results: $315K energy savings + $185K productivity gains. Report pays for itself in 30 days.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ConversionUrgencyBanner;


